import { TDeviceType } from '@cian/ui-kit';
import { IButtonProps } from '@cian/ui-kit/button/types';

export const MAX_VISIBLE_FACTOIDS = 6;

export const SHOW_MORE_BUTTON_PROPS: Record<TDeviceType, Partial<IButtonProps>> = {
  desktop: {
    size: 'XS',
    theme: 'stroke_primary',
  },
  tablet: {
    size: 'M',
    fullWidth: true,
    theme: 'fill_secondary',
  },
  phone: {
    size: 'M',
    fullWidth: true,
    theme: 'fill_secondary',
  },
};
